module.exports = __webpack_public_path__ + "img/sucess.e5f29632.svg";